<template lang="pug">
include index.pug
</template>

<script>
import ProgressBarItem from './progressBarItem'
import { ApplicationSteps } from '@/models'
import { createNamespacedHelpers } from 'vuex'

import { getterTypes } from '@/store/application'
const applictionStore = createNamespacedHelpers('application')

export default {
  name: 'ProgressBar',
  components: {
    progressBarItem: ProgressBarItem
  },
  data() {
    return {
      currentStep: undefined
    }
  },
  computed: {
    ...applictionStore.mapState({
      centerSelected: (state) => state.center !== undefined
    }),
    ...applictionStore.mapGetters({
      personApplication: getterTypes.CURRENT,
      personsCount: getterTypes.PERSONS_COUNT,
      persons: getterTypes.PERSONS,
      photoChoiceAvailable: getterTypes.PHOTO_CHOICE_AVAILABLE,
      timeBookingAvailable: getterTypes.TIMEBOOKING_AVAILABLE,
      allSituationCompleted: getterTypes.ARE_ALL_SITUATIONS_COMPLTED
    }),
    isFlowStartStep: function () {
      return this.personsCount === 0 || (this.personApplication === undefined && !this.allSituationCompleted)
    },
    isGroupOrder: function () {
      return this.personsCount > 1
    }
  },
  watch: {
    $route(to) {
      if (to.meta.applicationStep) {
        this.setCurrentStep(to.meta.applicationStep)
      }
    }
  },
  mounted: function () {
    this.setCurrentStep(this.$route.meta.applicationStep ? this.$route.meta.applicationStep : ApplicationSteps.Start)
  },
  methods: {
    setCurrentStep: function (key) {
      if (this.personsCount > 1 && key === ApplicationSteps.Situation && this.personApplication) {
        this.currentStep = this.personApplication.id
      } else {
        this.currentStep = key
      }
    }
  }
}
</script>
